import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/elements/instagram-author.png")